import React from 'react';
import { Box } from '@mui/material';

const styles = {
  tabPanel: {
    height: '100%',
    minHeight: '400px'
  }
};

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      style={styles.tabPanel}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2, height: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default TabPanel;